import {
  getAddbillhome,
  getAddbillpersonmanually,
  getEditBill,
  getFinalBillDashboard,
  getVerifyBillDashboard
} from '../constants/tealiumDataConfig'

import { PAGE_NAMES } from '../constants/tealiumData'

const getPageviewPayload = (route, payload) => {
  switch (route) {
    case PAGE_NAMES.ADD_BILL_HOME:
      return getAddbillhome()
    // case PAGE_NAMES.ADD_BILL_PERSON_MANUALLY:
    //   return getAddbillpersonmanually(payload)
    case PAGE_NAMES.ADD_BILL_MANUALLY:
      return getAddbillpersonmanually(payload) // method name should be changed
    case PAGE_NAMES.EDIT_BILL:
      return getEditBill(payload)
    case PAGE_NAMES.FIND_BILL_DASHBOARD:
      return getFinalBillDashboard(payload)
    case PAGE_NAMES.VERIFY_BILL_DAHSBOARD:
      return getVerifyBillDashboard(payload)
    default:
      return null
  }
}

export default getPageviewPayload
